import { Component, AfterViewInit, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../authentication.service';
import { MainService as Portal_main } from '../../../portal/service/main.service';
import { MainService } from '../../service/main.service';
import { TranslationService } from '../../service/translation.service';
import { Router } from '@angular/router';
import { session } from '../../../../environments/environment.session'
import { MainService as MD_mainService } from '../../../md/service/main.service';
// import {ServicesService} from '../../service/services.service'
import { Location } from '@angular/common';
@Component({
  selector: '[app-sdp-header]',
  templateUrl: './sdp-header.component.html',
  styleUrls: ['./sdp-header.component.css']
})
export class SdpHeaderComponent {
constructor(private router: Router, public portal_main: Portal_main, public mainService: MainService,
      public auth: AuthenticationService , private MD_mainService:MD_mainService,private location: Location, public translation: TranslationService) { 
        // this.ss.headerMess='Services'
      }
  
    erpUser: any = {};
    noti_count: any = 0;
    noti_data: any;
    message_count: any;
    hidden = true;
    languageOptions = [
      { language_cd: 'ENG', language_desc: 'English' },
      { language_cd: 'HIN', language_desc: 'हिन्दी' }
    ]
    async ngOnInit() {
       try{
      this.erpUser = JSON.parse(atob(session.erpUser));
    }catch(err){
    return
    }
      if (!this.auth.allLanguage || this.auth.allLanguage.length === 0) {
        this.auth.allLanguage = this.languageOptions
      } else {
        const filtered = this.auth.allLanguage.filter((lang: any) => ['ENG', 'HIN'].includes(lang.language_cd))
        const mapByCode: any = {}
        for (const item of filtered) {
          mapByCode[item.language_cd] = item
        }
        for (const fallback of this.languageOptions) {
          if (!mapByCode[fallback.language_cd]) {
            mapByCode[fallback.language_cd] = fallback
          }
        }
        this.auth.allLanguage = Object.values(mapByCode)
      }
      if (!this.auth.language_cd || this.auth.language_cd === 'ENG') {
        this.auth.language_cd = 'HIN'
      }
      this.mainService.language_cd = this.auth.language_cd
      this.translation.setLanguage(this.auth.language_cd)
      if (this.erpUser.role_cd.includes("SUPER_ADMIN")) {
        this.hidden = false;
      } else {
        this.hidden = true
      }
      await this.portal_main.getUserImage(this.erpUser['user_id']);
      await this.portal_main.getAccImage(this.erpUser['b_acct_id']);
      await this.portal_main.getAccountInfo(this.erpUser['b_acct_id']);
      await this.portal_main.getHeaderInfo(this.erpUser['b_acct_id']);
      await this.getcurrentroleswithresources()
      await this.changeLanguage();
      // this.mainService.accInfo = this.portal_main.accInfo;
      let message = await this.portal_main.getMessageCount(this.erpUser['b_acct_id'], this.erpUser['user_id']);
      console.log(message)
      this.message_count = message
      console.log(this.message_count)
    }
  


    
  roles:any;
  // moduleRoleObj:any = {};
//oc
  async getcurrentroleswithresources() {
    // this.tspinner.show('','');
    let obj:any = {}
    obj['b_acct_id'] = this.erpUser.b_acct_id
    console.log(obj)
    var resp = await this.MD_mainService.getcurrentroleswithresources(JSON.stringify(obj));
    console.log(resp);
    if (resp['error'] == false) {
      this.roles =null;

      for (let i = 0; i < resp.data.length; i++) {
        this.MD_mainService.moduleRoleObj[resp.data[i]['role_cd']] = resp.data[i]['role_name']
      }
      var role_cd = this.erpUser['role_cd'];

      for (let i = 0; i < role_cd.length; i++) {
        if(!['HR_EMP','CFC_EMP'].includes(role_cd[i])){
          if (!this.roles) {
            this.roles = this.MD_mainService.moduleRoleObj[role_cd[i]]
          } else {
            this.roles = this.roles + " , " + this.MD_mainService.moduleRoleObj[role_cd[i]]
          }
        }
     
      }
      // this.tspinner.hide()
    } else {
      // this.spinner.hide()
      // Swal.fire("Error", "..Error while getting  roles", 'error');
    }
  }


    changeLanguage() {
      this.mainService.language_cd = this.auth.language_cd
      this.mainService.allLanguage = this.auth.allLanguage
      this.translation.setLanguage(this.auth.language_cd)
    }
  
    home() {
      this.router.navigate(['/index'])
    }
  
  
    ngAfterViewInit() {
    }
      async logOut(){
  
        sessionStorage.removeItem("1001");
        sessionStorage.removeItem("1000");
        sessionStorage.removeItem("1005");
        session.erpUser = undefined
        this.router.navigate(['/login']);
  
    }

    back(){
      this.location.back();
    }

    checkNoti(){
      return this.erpUser && this.erpUser.role_cd.includes('Officer')
    }
    toggleLanguage() {
  if (this.auth.language_cd === 'HIN') {
    this.auth.language_cd = 'ENG';
  } else {
    this.auth.language_cd = 'HIN';
  }

  // बाकी सारी logic जो पहले changeLanguage() में थी — उसे call कर दो
  this.changeLanguage();
}
  }
  
